import {
  Component,
  OnInit,
  OnChanges,
  Input,
  SimpleChanges
} from "@angular/core";
import { DataService } from "./data.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import * as HSET from "./settings";
import { WidgetConfig } from "../../../class/widget-config";
import { GenericUtils } from './../../../utilities/generic-utils';

addMore(Highcharts);

@Component({
  selector: "widget-pie-chart",
  templateUrl: "./widget-pie-chart.component.html",
  styleUrls: ["./widget-pie-chart.component.scss"],
  providers: [DataService]
})
export class WidgetPieChartComponent
  implements OnInit, OnChanges {
  @Input() FILTERS;
  @Input() WIDGETCONFIG: WidgetConfig;
  @Input() CHARTCONFIG;

  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;

  loadData = false;
  errorMessage = "";
  mockChart = null;

  Alldata;
  dropdownItems = ["All"];

  constructor(
    private translateService: TranslateService,
    private dataService: DataService,
    private genericUtils: GenericUtils
    
  ) { }

  ngOnChanges(changes: SimpleChanges) {

    this.getData();
  }

  ngOnInit() {
    this.translateService
      .get("PERFORMANCE.DELIVERY.REASON_FOR_FAILURE")
      .subscribe(text => {
        this.WIDGETCONFIG.title = this.WIDGETCONFIG.title || text;
      });

  }

  getData() {
    this.errorMessage = "";
    this.chartOptions = null;
    this.mockChart = null;
    this.loadData = true;
    const queryParams = { ...this.FILTERS};
    try {
      this.dataService
        .getData(this.WIDGETCONFIG.api, queryParams, this.WIDGETCONFIG)
        .subscribe(
          chartData => {
            this.loadData = false;
            if (chartData) {
              this.chartOptions = this.dataService.createChart(
                chartData,
                this.CHARTCONFIG[0]
              );

            } else {
              this.handleError("ERROR_MSG.NO_DATA");
            }
          },
          err => {
            this.handleError("ERROR_MSG.SYSTEM_ERROR");
          }
        );
    } catch (error) {
      console.log(`Exception in making a call to the backend for widget-pie-chart, widgetId : ${this.WIDGETCONFIG.id}`)
      this.handleError("ERROR_MSG.SYSTEM_ERROR");
    }

  }

  handleError(message) {
    this.errorMessage = message;
    this.mockChart = [{ chart: HSET.chartData, width: 12 }];

  }


  // chartData.series.map(data => {

  //   this.dropdownItems.push(data[0]);
  // });

  // this.Alldata = chartData;

  // public dropdownChange(value: any): void {
  //   if (value !== "All") {
  //     const newCahrdata = { series: [], total: this.Alldata.total };
  //     const filter = this.Alldata.series.filter(data => data[0] === value);
  //     newCahrdata.series = filter;
  //     this.chartOptions = this.dataService.createChart(
  //       newCahrdata,
  //       this.WIDGETCONFIG
  //     );
  //   } else {
  //     this.chartOptions = this.dataService.createChart(
  //       this.Alldata,
  //       this.WIDGETCONFIG
  //     );
  //   }
  // }
}
